__turbopack_context__.v({
  "item": "ArticleCreditsBlok-module__OFpJ5a__item",
  "root": "ArticleCreditsBlok-module__OFpJ5a__root",
  "text": "ArticleCreditsBlok-module__OFpJ5a__text",
});
